import Axios from 'axios';
var AccountService = (function () {
    function AccountService() {
    }
    AccountService.prototype.getList = function (params) {
        return Axios.get('supplierclientapi/stock_warning_rule/list', { params: params });
    };
    AccountService.prototype.updateWarningRuleStatus = function (params) {
        return Axios.post('supplierclientapi/stock_warning_rule/change_status', params);
    };
    AccountService.prototype.getWarningTypeOptions = function (params) {
        return Axios.get('supplierclientapi/stock_warning_rule/shelflife_stock_warning_type_option', { params: params });
    };
    AccountService.prototype.createWarningRule = function (params) {
        return Axios.post('supplierclientapi/stock_warning_rule/create', params);
    };
    AccountService.prototype.updateWarningRule = function (params) {
        return Axios.post('supplierclientapi/stock_warning_rule/update', params);
    };
    AccountService.prototype.getWarningList = function (params, warningType) {
        return Axios.get("supplierclientapi/" + warningType + "/list", { params: params });
    };
    AccountService.prototype.getWarningDetailList = function (params, warningType) {
        return Axios.get("supplierclientapi/" + warningType + "/detail_list", { params: params });
    };
    AccountService.createInstance = function () {
        AccountService.getInstance();
    };
    AccountService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return AccountService;
}());
export default AccountService;
